import React from "react";
import styles from "./Modal.module.scss";
import CrossIcon from "@/components/SVGComponents/CrossIcon";

interface ModalProps {
  modalOpen: boolean;
  closeModal: (value: boolean) => void;
  heading: React.ReactNode;
  children: React.ReactNode;
  doNotClose?: boolean;
  className?: string | undefined;
  bodyClassName?: string | undefined;
}

const Modal = ({
  modalOpen,
  closeModal,
  heading,
  children,
  doNotClose = false,
  className = "",
  bodyClassName = "",
}: ModalProps) => {
  if (modalOpen) {
    return (
      <div
        className={styles.mainContainer}
        onMouseDown={(e) => {
          e.stopPropagation();
          !doNotClose && closeModal(false);
        }}
      >
        <div
          className={`${styles.modalDiv} ${className}`}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <div className={styles.modalHeader}>
            <div className={styles.headingContent}>{heading}</div>
            <button
              type="button"
              className={styles.closeButton}
              onClick={() => closeModal(false)}
              aria-label="Close"
            >
              <CrossIcon />
            </button>
          </div>
          <div className={`${styles.modalBody} ${bodyClassName}`}>{children}</div>
        </div>
      </div>
    );
  }
};

export default Modal;
